import React, { useState, useEffect, ChangeEventHandler, FocusEventHandler } from "react";

interface IPropsType {
    label: string,
    name: string,
    value?: string | number,
    required: boolean,
    removeValidationMsg?: boolean,
    type?: string,
    onChange?: ChangeEventHandler<HTMLInputElement>,
    onBlur?: FocusEventHandler<HTMLInputElement>,
    inputClass?: string,
    tooltipText?: string,
    placeholder?: string,
    children?: React.ReactNode,
    additionalLabelClass?: string,
    additionalInputClass?: string,
    wrapInsideContainer?: boolean
    errorMessage?: string,
    allowOnlyNumbers?: boolean,
    allowOnlyDecimals?: boolean,
    defaultValue?: string,
    disabled?: boolean
}


function textInput(props: IPropsType) {
    const stdLabelClass = 'field-label-16-roboto ';
    const stdInputClass = (!props.removeValidationMsg && props.errorMessage ? "is-invalid" : "");
    const numberInputOnWheelPreventChange = (e) => {
        if (props.type == "number") {
            e.target.blur()
            e.stopPropagation()
            setTimeout(() => {
                e.target.focus()
            }, 0);
        }
    }
        const inputComponent = (<input disabled={props.disabled} onWheel={numberInputOnWheelPreventChange} type={props.type ? props.type : "text"} 
        {...
            (props.value && { value: props.value })
           
        }
        {...
            (props.allowOnlyNumbers && { step: 1 })
        }
        name={props.name}
        /*value={props.value}*/
        defaultValue={props.defaultValue}
        
        onChange={(e) => {
            props.onChange(e);
        }}
        onBlur={props.onBlur} required={props.required} className={(props.inputClass ? props.inputClass : stdInputClass) + (props.additionalInputClass ? ' ' + props.additionalInputClass : '')} placeholder={props.placeholder}
    />);

    const errorComponent = (<React.Fragment>{!props.removeValidationMsg && props.errorMessage && <p className="errorText">{props.errorMessage}</p>}</React.Fragment>);

    if (props.wrapInsideContainer) {
        return (
            <React.Fragment>
                <div className="inputWrapper">
                    {props.label && <span>{props.label}</span>}
                    {inputComponent}
                    {errorComponent}
                </div>
            </React.Fragment>
        );
    }

    return (
        <React.Fragment>
            <div className="inputWrapper">
                {props.label && <span>{props.label}</span>}
                {inputComponent}
                {errorComponent}
            </div>
        </React.Fragment>
    );


}

export default textInput;